import { useEffect, useState } from 'react';
import type { ConnectbaseNoticeStatus } from '~/api/projectConnectbaseTasks';
import { connectbaseLayerStatusText } from './status';
import { useStatusMessageShown } from './useStatusMessageShown';

/**
 * Screen-reader announcement for the fiber lit buildings layer's ConnectBase status, which sighted users get from the
 * layer's dimmed label and tooltip. The live region always mounts empty and fills after mount, since a region rendered
 * together with its text isn't announced.
 */
export function FiberConnectbaseNote({
  projectId,
  layerName,
  status,
}: {
  projectId: string;
  layerName: string;
  status: ConnectbaseNoticeStatus | undefined;
}) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  useStatusMessageShown(projectId, 'fiberLitBuildings', status);
  return (
    // biome-ignore lint/a11y/useSemanticElements: <output> is for form results, not a status message
    <div role="status" className="sr-only" data-testid="toc-fiber-connectbase-status">
      {mounted && status && connectbaseLayerStatusText(layerName, status)}
    </div>
  );
}
